import React from 'react';
import FieldLabel from './field-label';
import FieldHelpText from './field-help-text';
import FieldWidth from './field-width';
import ConditionId from './condition-id';
import {TextField} from '../../../libs/react-components-admin/fields/text-like-field';

class RadioField extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model || {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateLabel(value) {
    this.setState(
      prevState => ({model: {...prevState.model, label: value, radioValue: value}}),
      () => this.props.onChange(this.state.model)
    );
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <div>
      <FieldLabel value={this.state.model.label}
                  onChange={v => this.updateLabel(v)}/>
      <FieldHelpText value={this.state.model.helpText}
                     onChange={v => this.updateModel('helpText', v)}/>
      <GroupName value={this.state.model.groupName}
                 onChange={v => this.updateModel('groupName', v)}/>
      <FieldWidth value={this.state.model.widthInPercent}
                  onChange={v => this.updateModel('widthInPercent', v)}/>
      <ConditionId id={this.props.id}
                   conditions={this.state.conditions}
                   value={this.state.model.conditionId}
                   onChange={v => this.updateModel('conditionId', v)}/>
    </div>;
  }

}
export default RadioField;

class GroupName extends React.Component {

  constructor(props) {
    super(props);
    let value = props.value;
    if (!value) {
      value = 'My radio group';
      props.onChange(value);
    }
    this.state = {
      value: value,
    };
  }

  updateValue(value) {
    this.setState(
      {value: value},
      () => this.props.onChange(this.state.value)
    );
  }

  render() {
    return <TextField label="Group name"
                      helpBlock="Give the exact same group name to all radios that belong to the same group (i.e. only one radio in the group can be selected)"
                      value={this.state.value}
                      onChange={v => this.updateValue(v)}/>
  }

}
